import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";

const AgeGateContext = createContext(null);

export function AgeGateProvider({ children }) {
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && localStorage.getItem("rx_age_ok") === "1") {
      setConfirmed(true);
    }
  }, []);

  const confirm = useCallback(() => {
    setConfirmed(true);
    if (typeof window !== "undefined") {
      try { localStorage.setItem("rx_age_ok", "1"); }
      catch (e) { console.warn("[AgeGateContext] storage error:", e); }
    }
  }, []);

  const value = useMemo(() => ({ confirmed, confirm }), [confirmed, confirm]);
  return <AgeGateContext.Provider value={value}>{children}</AgeGateContext.Provider>;
}

export const useAgeGate = () => useContext(AgeGateContext);
